// Top attachments: a front sight blade, the Star Ranger's star scope, or the Cork Popper's cork on a
// string (hanging under the barrel; the cork is pale cream, never blaze-hued).
import { detailStroke, type Part, part } from '../../passes.ts';
import { box, line, roundPoly, starPts } from '../../shapes.ts';
import { type GunKit, lrect } from './types.ts';

export function top(g: GunKit): Part[] {
  const { kind } = g.r.top;
  const { x, len, th } = g.r.barrel;
  const rc = g.r.receiver;
  if (kind === 'sight') return [lrect(g, g.r.second, x + len - 9, -th / 2 - 5, 6, 7, 2)];
  if (kind === 'starScope') {
    const sx = rc.x + 6;
    const sw = g.pal.sw('ui.money');
    const pts = starPts(sx + 36, rc.y - 13, 8.5, 4, 5, -90);
    return [
      lrect(g, 'mach.front', sx + 8, rc.y - 5, 5, 6, 1.5),
      lrect(g, 'mach.front', sx + 24, rc.y - 5, 5, 6, 1.5),
      lrect(g, g.r.gripTok, sx, rc.y - 19, 36, 12, 5),
      part(roundPoly(pts, 1.2), sw, box(sx + 27, rc.y - 22, 18, 18)),
    ];
  }
  if (kind === 'cork') {
    const cx = x + len * 0.55;
    const cy = th / 2 + 15;
    const sw = g.pal.sw(g.r.accent);
    const string = g.pal.sw(g.r.second).outline;
    return [
      part(
        roundPoly(
          [
            [cx - 5, cy - 5],
            [cx + 5, cy - 5],
            [cx + 6.5, cy + 6],
            [cx - 6.5, cy + 6],
          ],
          2,
        ),
        sw,
        box(cx - 6.5, cy - 5, 13, 11),
        {
          detail: (c) =>
            detailStroke(
              c,
              line([
                [cx - 2, cy - 5],
                [x + len - 4, th / 2 - 1],
              ]),
              string,
              g.ow * 0.6,
            ),
        },
      ),
    ];
  }
  return [];
}
